// const API_BASE_URL = "https://securetracks-bmbrcjbufwhqhjdd.eastasia-01.azurewebsites.net/";
const API_BASE_URL = "http://localhost:8080"; // Cập nhật URL API của bạn nếu cần
 // Cập nhật URL API của bạn nếu cần

export default API_BASE_URL;
